import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DnD from "./Dnd";
import { message, Button, Divider, Table, Space, Select } from "antd";
import actions from "../../../redux/ReconAndSettlement/actions";

const { Option } = Select;

const columns = [
  { title: "Name", dataIndex: "name" },
  { title: "From Time", dataIndex: "fromTime" },
  { title: "To Time", dataIndex: "toTime" },
  { title: "Duration In Hrs.", dataIndex: "duration" },
];

const Uploads = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    cycleNo: "",
    fileType: "", // 🔁 MODIFIED
    date: "",
  });

  const [file, setFile] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [fetchData, setFetchData] = useState([]);

  const { uploadReconData } = useSelector((state) => ({
    uploadReconData: state?.reconReducer?.uploadReconData,
  }));

  const handleSubmit = () => {

    if (!file) {
      message.error("No file selected");
      return;
    }

    if (!formData.fileType) {
      message.error("Please select a file type"); 
      return;
    }

    const fileExt = file?.name?.split(".").pop()?.toLowerCase();
    const expectedExt = "csv"; // ✅ All types are CSV

    if (fileExt !== expectedExt) {
      message.error(`Invalid file. Please upload a .${expectedExt} file`);
      return;
    }



    const form = new FormData();
    form.append("file", file);
    form.append("fileType", formData.fileType); // ✅ File type is Match/Unmatch/Missing
        
    dispatch(actions.UploadFile({ file: form }));
  };

  useEffect(() => {
    if (
      uploadReconData?.loading === true &&
      uploadReconData?.error?.error === null
    ) {
      messageApi.destroy();
      messageApi.open({
        type: "loading",
        content: "Uploading...",
      });
    } else if (
      uploadReconData?.loading === false &&
      uploadReconData?.error !== null
    ) {
      messageApi.destroy();
      messageApi
        .open({
          type: "error",
          content: uploadReconData?.error?.error,
          duration: 3,
        })
        .then(() => dispatch(actions.uploadDataReset()));
    } else if (
      uploadReconData?.loading === false &&
      uploadReconData?.error === null &&
      uploadReconData?.notified === false &&
      uploadReconData?.data?.message?.length > 0
    ) {
      messageApi.destroy();
      messageApi
        .open({
          type: "success",
          content: "File Uploaded Successfully",
          duration: 3,
        })
        .then(() => dispatch(actions.uploadDataReset()));
    }
  }, [uploadReconData]);

  useEffect(() => {
    const myData = Array.isArray(uploadReconData?.data)
      ? uploadReconData?.data
      : [uploadReconData?.data];

    const fetchedData = myData
      ?.filter((file) => file && file.downloadUrl)
      .map((file, index) => ({
        name: `Transaction-${fetchData.length + index + 1}`,
        fromTime: "N/A",
        toTime: "N/A",
        duration: "N/A",
        date: file.date || "N/A",
        fileUrl: file.downloadUrl,
      }));

    setFetchData((prev) => [
      ...prev,
      ...fetchedData.filter(
        (fd) => !prev.some((p) => p.fileUrl === fd.fileUrl)
      ),
    ]);
  }, [uploadReconData?.data]);

  return (
    <div>
      {contextHolder}
      <div className="filter-container-row">
        {/* ✅ UPDATED: File Type dropdown for Match/Unmatch/Missing */}
        <div style={{ marginBottom: 12 }}>
          <Select
            placeholder="Select File Type"
            className="filter-select"
            style={{ width: 220 }}
            value={formData.fileType || undefined}
            onChange={(value) =>
              setFormData((prev) => ({ ...prev, fileType: value }))
            }
          >
            <Option value="match">Match</Option>
            <Option value="unmatch">Unmatch</Option>
            <Option value="missing">Missing</Option>
            <Option value="transaction_report">Transaction Report</Option>
          </Select>
        </div>
      </div>

      <div className="filter-container">
        <DnD
          setFormDataState={(file) => {
            setFile(file);
          }}
        />

        <Button
          type="primary"
          className="filter-button"
          onClick={handleSubmit}
          disabled={uploadReconData?.loading === true}
        >
          Submit
        </Button>
      </div>

      <Divider />
      {Array.isArray(fetchData) && fetchData?.length > 0 && (
        <Table
          columns={[
            ...columns,
            {
              title: "Actions",
              render: (_, record) => (
                <Space>
                  <a
                    href={record?.fileUrl}
                    style={{ cursor: "pointer" }}
                    className="filter-button"
                    download
                  >
                    Download File
                  </a>
                </Space>
              ),
            },
          ]}
          rowKey={(record) => record?.name}
          dataSource={fetchData}
          loading={uploadReconData?.loading}
        />
      )}
    </div>
  );
};

export default Uploads;
